import { useTranslateEnum } from '@festina-life/ui/hooks'

import { useHook } from '../../../lenteHooks'
import { findMemberIcon } from '../../memberInfo/utilities'

export const MemberIconFromLegalEntity = () => {
  const translateEnum = useTranslateEnum()
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const { data: personVersion } = useHook(
    'fetchers.crm.useFetchPersonVersionLatest',
  )({
    tenantId,
    personId: ownerId,
  })

  return (
    <img
      src={findMemberIcon(personVersion?.gender)}
      title={translateEnum('legalEntity.enum.Gender', personVersion?.gender)}
      className="size-14"
    />
  )
}
